import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { D1IssuersEditCard } from "./edit_card";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";

export const D1IssuersEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <D1IssuersEditCard
          id={Number(id)}
          client={Clients.D1}
          table_name={Tables.D1_ISSUERS}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.D1}
          audit_table_name={Tables.D1_ISSUERS}
        />
      </div>
    </div>
  );
};
